import Vue from 'vue';

// Vue.js 2 wrapper for Microsoft Authentication Library (https://github.com/ahermant/vue-msal-browser)
import { default as msalPlugin } from 'vue-msal-browser';

const msalConfig = {
  auth: {
    clientId: "ad11b807-daca-45db-8d4c-8163c1a067c6",
    authority: "https://leebcustomer.b2clogin.com/16161b47-0150-418f-b01b-28ed514a1d59/B2C_1_Cutomer1",
    knownAuthorities: ["leebcustomer.b2clogin.com"],
    validateAuthority: true,
    redirectUri: window.location.origin + "/login/",
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage"
  },
  mode: "redirect"
}

Vue.use(msalPlugin, msalConfig);
